import Emitter from 'component-emitter';
import { HubConnection } from '@microsoft/signalr';

// TODO: описать payload
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type iDontKnow = any;

export class BalanceConnection {
  constructor(hubConnection: HubConnection, emmitter: Emitter) {
    hubConnection.on('balanceUpdated', (payload: iDontKnow) => emmitter.emit(
      'update-balance',
      {
        balance: payload.balance,
        withdrawalBalance: payload.withdrawalBalance,
      }),
    );
  }
}
